import { useEffect, useRef } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(max-width: 768px)").matches) return;

    const dot = dotRef.current;
    const ring = ringRef.current;
    let mx = 0, my = 0, rx = 0, ry = 0;

    const move = (e) => {
      mx = e.clientX; my = e.clientY;
      if (dot) dot.style.transform = `translate(${mx}px, ${my}px) translate(-50%, -50%)`;
    };

    const loop = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      if (ring) ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      requestAnimationFrame(loop);
    };

    const hoverIn = () => { dot?.classList.add("hover"); ring && (ring.style.opacity = "0"); };
    const hoverOut = () => { dot?.classList.remove("hover"); ring && (ring.style.opacity = "1"); };

    document.addEventListener("mousemove", move);
    document.querySelectorAll("a, button, input, textarea, select, [role='button'], [data-magnetic]").forEach((el) => {
      el.addEventListener("mouseenter", hoverIn);
      el.addEventListener("mouseleave", hoverOut);
    });
    const raf = requestAnimationFrame(loop);

    // Re-bind hover when DOM changes
    const observer = new MutationObserver(() => {
      document.querySelectorAll("a, button, input, textarea, select, [role='button'], [data-magnetic]").forEach((el) => {
        el.addEventListener("mouseenter", hoverIn);
        el.addEventListener("mouseleave", hoverOut);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      document.removeEventListener("mousemove", move);
      cancelAnimationFrame(raf);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="kv-cursor" aria-hidden="true" data-testid="custom-cursor-dot" />
      <div ref={ringRef} className="kv-cursor-ring" aria-hidden="true" />
    </>
  );
}
